"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher_1 = require("./lib/EventDispatcher");
var mobx_1 = require("mobx");
var interfaces_1 = require("data/interfaces");
var helper_1 = require("lib/functions/helper");
var Model = (function () {
    function Model(gate, dataStore) {
        this.gate = gate;
        this.dataStore = dataStore;
        this.dispatcher = new EventDispatcher_1.EventDispatcher();
        this.validateFunctions = {};
        this.executeOneTime = 0;
        this.isTableUserVisible = false;
    }
    Model.prototype.test = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("PDF Model.test");
                return [2];
            });
        });
    };
    Model.prototype.addValidateFunction = function (key, f) {
        this.validateFunctions[key] = f;
    };
    Model.prototype.removeValidateFunction = function (key) {
        this.validateFunctions[key] = null;
    };
    Model.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, key, f, r;
            return __generator(this, function (_a) {
                results = [];
                for (key in this.validateFunctions) {
                    f = this.validateFunctions[key];
                    if (!f) {
                        continue;
                    }
                    r = f();
                    results.push(r);
                }
                if (results.includes(false)) {
                    return [2, false];
                }
                return [2, true];
            });
        });
    };
    Model.prototype.getApiKeyBySlug = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/api/key/credentials", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.user = r.data;
                            if (Object.keys(r.data).length > 0) {
                                this.json_data.api_key_user_id = r.data.userId;
                                this.json_data.api_key_profile_id = r.data.profileId;
                                this.json_data.profile = r.data.profile;
                                this.json_data.type = r.data.type;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_1 = _a.sent();
                        console.log("some error with getApiKeyBySlug", error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getHowDidYouKnowAboutUsList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, newHowDidYouKnowList, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/admissions/how-did-you-know-about-us", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            newHowDidYouKnowList = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name;
                                return ({
                                    name: name,
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER
                                });
                            });
                            this.json_data.howDidYouKnowAboutUsList = newHowDidYouKnowList;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_2 = _a.sent();
                        console.log("some error with getHowDidYouKnowAboutUsList", error_2);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getPrograms = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var campusId, options, r, newPrograms, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        campusId = helper_1.getPartsByDelimiter(value)[0];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/programs/" + campusId, {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            newPrograms = r.data.map(function (_a) {
                                var id = _a.id, name = _a.name, code = _a.code, description = _a.description;
                                return ({
                                    name: name,
                                    value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + code + helper_1.DELIMITER + description
                                });
                            });
                            this.json_data.programs = newPrograms;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_3 = _a.sent();
                        console.log("some error with getPrograms", error_3);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getCampuses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, newCampuses, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/campuses", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            if (Object.keys(r.data).length > 0) {
                                newCampuses = r.data.map(function (_a) {
                                    var id = _a.id, name = _a.name, abbreviation = _a.abbreviation, checked = _a.checked;
                                    return ({
                                        name: name,
                                        value: "" + id + helper_1.DELIMITER + name + helper_1.DELIMITER + abbreviation + helper_1.DELIMITER + checked
                                    });
                                });
                                this.json_data.campuses = newCampuses;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_4 = _a.sent();
                        console.log("some error with getCampuses", error_4);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.edularCoreSignIn = function (credentials) {
        return __awaiter(this, void 0, void 0, function () {
            var newCredentials, r, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        newCredentials = __assign(__assign({}, credentials), { slug: process.env.SLUG, acronym: process.env.ACRONYM_SLUG });
                        return [4, this.gate.request("/v3/sign-in", {
                                data: newCredentials
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.user = r.data;
                            this.json_data = this.user.json_data;
                            this.json_data.type = this.user.type;
                            if (this.user.type === interfaces_1.UserProfileType.Staff) {
                                this.json_data.advisor_name = this.user.firstName + " " + this.user.lastName;
                                this.json_data.advisor_email = this.user.email;
                                this.json_data.link = "" + process.env.BASE_DOMAIN;
                                this.json_data.user_staff_id = "" + this.user.userId;
                                this.json_data.x_profile_staff_id = "" + this.user.profileId;
                            }
                            else {
                                this.json_data.user_student_id = "" + this.user.userId;
                                this.json_data.x_profile_student_id = "" + this.user.profileId;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_5 = _a.sent();
                        console.log("some error with signIn", error_5);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.searchStudent = function (search) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, userId, profileId, options, r, error_6;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this.user, userId = _a.userId, profileId = _a.profileId;
                        options = {
                            slug: process.env.SLUG,
                            user_id: userId,
                            x_profile_id: profileId,
                            search: search
                        };
                        return [4, this.gate.request("/v3/search-student", {
                                data: options
                            })];
                    case 1:
                        r = _b.sent();
                        if (r.success) {
                            this.userList = r.data;
                            if (r.data.length <= 0) {
                                this.json_data.full_name = "";
                                this.json_data.first_name = "";
                                this.json_data.last_name = "";
                                this.json_data.email = "";
                                this.json_data.address = "";
                                this.json_data.city = "";
                                this.json_data.zip = "";
                                this.json_data.cell_phone = "";
                                this.json_data.start_date = "";
                                this.json_data.program = "";
                            }
                            this.isTableUserVisible = true;
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_6 = _b.sent();
                        console.log("some error with signIn", error_6);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.searchEmail = function (search) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, userId, profileId, options, r, error_7;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this.user, userId = _a.userId, profileId = _a.profileId;
                        options = {
                            slug: process.env.SLUG,
                            user_id: userId,
                            x_profile_id: profileId,
                            search: search
                        };
                        return [4, this.gate.request("/v3/check-email", {
                                data: options
                            })];
                    case 1:
                        r = _b.sent();
                        if (r.success) {
                            this.checkEmail = r.data;
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_7 = _b.sent();
                        console.log("some error with signIn", error_7);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], Model.prototype, "executeOneTime", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "user", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "userList", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "isTableUserVisible", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "checkEmail", void 0);
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=data:application/json;base64,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